import { INVITATION_CODE_PARAM } from "./constants";
const regExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export function getValidInvitationCodeSearchParam() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get(INVITATION_CODE_PARAM);
    return code?.match(regExp) ? code : undefined;
}
//# sourceMappingURL=getValidInvitationCodeSearchParam.js.map